import {get} from './api';
import {
  uriGetBuStylesFromBuAlias,
  uriGetGroupExceptionsFromBuAlias,
  uriGetProductExceptionsFromBuAlias,
} from './endpoints';

export const getBusInfo = async (isNotClient: boolean, busMap: any) => {
  let busStyles: any;
  if (isNotClient) {
    busMap = [];
    busStyles = await get(uriGetBuStylesFromBuAlias('NOTCLIENT'));
    return [].concat(busStyles?.data?.items?.[0]);
  } else {
    busStyles = await Promise.all(
      Object.keys(busMap).map(async (key) => {
        const buStyles: any = await get(uriGetBuStylesFromBuAlias(key));
        return buStyles?.data?.items?.[0];
      })
    );
  }
  return [].concat(busStyles);
};

export const getBusExceptions = async (scope: string, busMap: any) => {
  const exceptions = (await Promise.all(
    Object.keys(busMap).map(async (key) => {
      let allExceptions: any[] = [];
      if (scope === 'product') {
        await get(uriGetProductExceptionsFromBuAlias(key))
          .then((res: any) => {
            allExceptions = res?.data?.items;
          })
          .catch((err: any) => {
            console.log('erro', err);
            if (err.status === 404) {
              allExceptions = [];
            }
          });
      }
      if (scope === 'group') {
        await get(uriGetGroupExceptionsFromBuAlias(key))
          .then((res: any) => {
            allExceptions = res?.data?.items;
          })
          .catch((err: any) => {
            console.log('erro', err);
            if (err.status === 404) {
              allExceptions = [];
            }
          });
      }
      return allExceptions?.filter(
        (exception: any) => exception.status === 'ACTIVE'
      );
    })
  )) as any[];
  return [].concat(...exceptions);
};
